'use client';

import type { FC, JSX } from 'react';
import React from 'react';
import type { ImageGalleryProps } from '@/components/imageGallery/ImageGalleryProps';
import dynamic from 'next/dynamic';
const ImageGallery = dynamic(() => import('@/components/imageGallery/ImageGallery'));

const ImageGalleryClientWrapper: FC<ImageGalleryProps> = (
  props: ImageGalleryProps
): JSX.Element => {
  return <ImageGallery {...props} />;
};

export default ImageGalleryClientWrapper;
